//
//
//
//
//
//
//
//

import drawMixin from '../pages/transactionScreen/drawMixin'
export default {
    mixins: [drawMixin],
    data() {
        return {
            showRightWidow: true
        }
    },
    mounted() {},
    methods: {}
}
